import React from 'react';
import Hero from '../components/home/Hero';
import ServicesGrid from '../components/home/ServicesGrid';
import TrustBand from '../components/home/TrustBand';
import WindowRepairCTA from '../components/home/WindowRepairCTA';
import CategoryGrid from '../components/home/CategoryGrid';
import StoreInfo from '../components/home/StoreInfo';

function HomePage() {
  return (
    <>
      <Hero />
      <ServicesGrid />
      <TrustBand />
      <WindowRepairCTA />
      <CategoryGrid />
      <StoreInfo />
    </>
  );
}

export default HomePage;
